import Vue from 'vue'
import VueResource from 'vue-resource'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import mixins from '@js/mixins.js'
import TextInput from '@component/dccore-form/textInput.vue'
import TranslationInput from '@component/dccore-form/translationInput.vue'
import MultiSelectInput from '@component/dccore-form/multiselect.vue'
import Checkbox from '@component/dccore-form/checkbox.vue'
import UploadPhoto from '@component/dccore-form/uploadPhoto.vue'
import toastr from '@js/toastr'

if ($('#badge_form').length) {
  Vue.use(VueResource)

  new Vue({
    el: '#badge_form',
    components: {
      RingLoader,
      TextInput,
      TranslationInput,
      MultiSelectInput,
      Checkbox,
      UploadPhoto
    },
    mixins: [mixins],
    data: {
      loading: 0,
      form: {
        entity: {
          file: null
        },
        options: {
          brands: [],
          errors: {},
        }
      },
      entityId: null,
      selectedBrands: [],
    },
    mounted() {
      this.getBrands()

      const idEl = document.querySelector('#entity_id')

      if (idEl) {
        this.entityId = idEl.value
        this.getBadge()
      }
    },
    methods: {
      createBadge() {
        this.loading++

        const url = Routing.generate('api_post_badge')
        const data = { data: this.form.entity }

        this.$http.post(url, data).then(() => {
          window.location.href = Routing.generate('badge_grid')
        }, response => {
          this.loading--
          this.handleAjaxError(response, this.form.options, response.data.message)
        })
      },
      getBadge() {
        this.loading++
        const url = Routing.generate('api_get_badge', {
          id: this.entityId,
          context: 'edit'
        })

        this.$http.get(url).then(response => {
          this.form.entity = response.data
          this.selectedBrands = this.form.entity.brands.map(brand => brand.id)

          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      getBrands() {
        this.loading++
        const url = Routing.generate('api_get_brands', { context: 'dropdown' })

        this.$http.get(url).then(response => {
          this.form.options.brands = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      updateBadge(redirect) {
        this.loading++

        const url = Routing.generate('api_patch_badge', { id: this.entityId })
        const data = { data: this.form.entity }

        this.$http.patch(url, data).then(() => {
          if (redirect) {
            document.location.href = Routing.generate('badge_grid')
          } else {
            toastr.success(Translator.trans('form.updated'))
            this.form.options.errors = {}
          }

          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response, this.form.options)
        })
      },
    }
  })
}
